export default {
  LIST_PROJECTS: '/sales/mtoProject/page',
  EXPORT: '/sales/mtoProject/export',
  DISCARD: '/sales/mtoProject/discard/',
  DELETE: '/sales/mtoProject/delete',
  SAVE: '/sales/mtoProject/save',
  DETAIL: '/sales/mtoProject/save/',
  AUDITION_LOGS: '/component/oa/approvalLogs/',
  //加projectCode查询
  EXPENSE_LIST_BY_SERVICE: '/maindata/service/expenseListByService',
  //查询线路列表
  LIST_ROUTE: '/maindata/route/listByPage',
  //新增或者编辑线路
  SAVE_OR_EDIT_ROUTE: '/maindata/route/save',
  // 合同变更记录
  CHANGE_RECORD: '/sales/mtoProject/listMtoProjectHistoricalVersion',
  // 从变更记录获取详情
  DETAIL_BY_ID: '/sales/mtoProject/getMtoProjectHistoricalVersion',
};
